<template>
    <div id="myConfig">

        <div class="section1">
            <h4>提现配置</h4>
            <el-row>
                <el-col :span="7">
                    <label style="width:120px;">最小提现金额：</label>
                    <el-input style="width:120px;" v-model="cashoutMinAmount" placeholder="请输入"></el-input> 元
                </el-col>

                 <el-col :span="7">
                    <label style="width:120px;">单笔手续费：</label>
                    <el-input style="width:120px;" v-model="cashoutFee" placeholder="请输入"></el-input> 元
                </el-col>

                <el-col :span="1">
                    <el-button type="primary"  @click="saveWithdrawConfigHandle()">保 存</el-button>
                </el-col>
            </el-row> 
        </div>

        <div v-if="flag==true" class="section1">
            <h4>购卡配置</h4>
            <el-row>
                <el-col :span="7">
                    <label style="width:120px;">购卡金额：</label>
                    <el-input style="width:120px;" v-model="buyCardCost" placeholder="请输入"></el-input> 元
                </el-col>

                <el-col :span="7">
                    <label style="width:120px;">是否允许购卡：</label>
                    <el-select v-model="isNable" placeholder="请选择" clearable>
                        <el-option value="1" label="允许"></el-option>
                        <el-option value="0" label="不允许"></el-option>
                    </el-select>
                </el-col>

                <el-col :span="1">
                    <el-button type="primary"  @click="updateBuyCardCost()">保 存</el-button>
                </el-col>
            </el-row> 
        </div>


    </div>
</template>

<script>
import {saveAgentWithdrawConfig, getAgentWithdrawConfig} from '@/api/system.js'
import common from '@/utils/common.js'

export default {
    data(){
        return {
            cashoutMinAmount: null,
            cashoutFee: null,

            //购卡金额
            buyCardCost: '',
            isNable: '',

            //购卡配置是否显示
            flag: false
        }
    },
    methods: {

        getWithdrawConfigHandle(){
            getAgentWithdrawConfig({}).then(res => {
                if(res.data.code == 200){
                    if(res.data.data.cashoutMinAmount){
                        this.cashoutMinAmount = res.data.data.cashoutMinAmount;
                    }
                    
                    if(res.data.data.cashoutFee){
                        this.cashoutFee = res.data.data.cashoutFee;
                    }
                    
                }
            })
        },

        //收款配置
        saveWithdrawConfigHandle(){
            if(this.cashoutMinAmount == null || this.cashoutMinAmount == ''){
                this.$message.error('请输入最小提现金额');    
                return ;
            }
            if(this.cashoutFee == null || this.cashoutFee == ''){
                this.$message.error('请输入单笔手续费');    
                return ;
            }
            let d = {
                cashoutMinAmount: Number(this.cashoutMinAmount),
                cashoutFee: Number(this.cashoutFee),
            }

            this.$confirm("确定保存此配置吗？", "提示" ,{          
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                saveAgentWithdrawConfig(d).then(res => {
                    if(res.data.code == 200){
                        this.$message.success(res.data.message)
                        this.getWithdrawConfigHandle();               
                    }else{
                        this.$message.error(res.data.message)
                    }
                })
            }).catch(() => {
                
            });
        },

        //查看购卡金额
        lookBuyCardCost(){
            common.sysRequest('bindPhone/buy/sim/price', {}, 'post').then(res => {
                if(res.data.code == 200){
                    let result = JSON.parse(res.data.data);
                    this.buyCardCost = result.agent_price/100;
                    this.isNable = result.isNable;
                }
            })
        },
        //更新购卡金额
        updateBuyCardCost(){
            this.$confirm("确定要保存吗？", "提示" ,{          
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                let data = {
                    price: this.buyCardCost * 100,
                    isNable: this.isNable
                }
                common.sysRequest('bindPhone/update/sim/price', data, 'post').then(res => {
                    if(res.data.code == 200){
                        this.$message.success(res.data.message)
                        this.lookBuyCardCost();
                    }else {
                        this.$message.error(res.data.message)
                    }
                })
            }).catch(() => {
                
            });
        },
        //是否显示购卡配置
        showbuyconfig() {
            if(sessionStorage.getItem("isCollect") == 1) {
                this.flag = false
            }
            else {
                this.flag = true
            }
        }
    },

    created(){
        this.getWithdrawConfigHandle(); 
        this.lookBuyCardCost();
        this.showbuyconfig();
    }
}
</script>

<style lang="less" scoped>
#myConfig {
    font-size: 13px;

    .section1{
        margin-bottom: 50px;
        h4 {
            font-size: 13px;
            font-weight: bold;
            padding-left: 5px;
            margin-bottom: 20px;
            margin-left: -8px;
            border-left: 3px solid #409eff;            
        }
        label{
            display:inline-block;
        }
        .el-row{
            margin-bottom: 20px;
        }
        span{
            text-align:left;
        }
    }


}
</style>

